orders-today
  .row
    .col-12
      a.job_no.badge.badge-inverse-info.badge-lg.mb-2(href="/orders/{opts.id}" target="_blank")
        span.index { locale().job_no }: &nbsp;
        span.value { opts.job_no }
  .order-wrap.row
    .left-wrap.col-md-6
      .group
        span.index { locale().client }: &nbsp;
        span.value
          span(if="{ opts.client_person_name }")  { opts.client_person_name } /
          span { opts.client_name }
      .group
        span.index { locale().product }: &nbsp;
        span.value { opts.product_name }
      .group
        span.index { locale().product_id }: &nbsp;
        span.value { opts.product_product_id }
      .group
        span.index { locale().required_num }: &nbsp;
        span.value { opts.required_num }
      .group
        span.index { locale().deadline }: &nbsp;
        span.value { opts.deadline }
      .group
        span.index { locale().order_type }: &nbsp;
        span.value.badge.badge-primary.order_type(if="{opts.is.new_order}") { this.locale().new_order }
        span.value.badge.badge-success.order_type(if="{opts.is.repeater}")   { this.locale().repeater }
        span.value.badge.badge-warning.order_type(if="{opts.is.changing}")   { this.locale().changing }
      .group
        span.index { locale().status }: &nbsp;
        span.value.badge.badge-inverse-default.status(if="{opts.is.information}") { this.locale().information}
        span.value.badge.badge-default.status(if="{opts.is.unofficial}") { this.locale().unofficial}
        span.value.badge.badge-warning.status(if="{opts.is.received}") { this.locale().received}
        span.value.badge.badge-inverse-primary.status(if="{opts.is.pending}") { this.locale().pending}
        span.value.badge.badge-inverse-danger.secondary.status(if="{opts.is.failed}") { this.locale().failed}
        span.value.badge.badge-success.status(if="{opts.is.done}") { this.locale().done}
    .right-wrap.col-md-6
      .group
        span.index { locale().orders_phases_description }（{getPhaseData(opts.phaseId).name }）: &nbsp;
        pre.desc.value(if="{ordersPhase.description}") { ordersPhase.description.value }
      .group(if="{ordersPhase.unit_price}")
        span.index {ordersPhase.unit_price.label}: 
        span.value(if="{ordersPhase.unit_price.value}") { ordersPhase.unit_price.value }
      .group(if="{ordersPhase.material}")
        span.index {ordersPhase.material.label}: 
        span.value(if="{ordersPhase.material.value}") { ordersPhase.material.value }
      .group(if="{ordersPhase.heat_treatment}")
        span.index {ordersPhase.heat_treatment.label}: 
        span.value(if="{ordersPhase.heat_treatment.value}") { ordersPhase.heat_treatment.value }
      .group
        span.index { locale().description }: &nbsp;
        pre.desc.value { opts.description }
  script(type="typescript").
    this.mixin('orders.today');
  style(scoped).
    .index {
      font-weight: bold;
    }
    .group {
      margin-bottom: .5rem;
    }
    
